(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["dinamicTemplate"] = factory();
	else
		root["dinamicTemplate"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REG_ATTR = /\s?[\w:-]+?=".*?"/g;
var REG_CLEAR_COMMENT = /<!--(?:.|\n)*?-->/g;
var REG_CLEAR_XMLHEAD = /<\?xml.*?\?>/g;

var tagArr = [];

/*------------------------------------------------------------*/

var LoopIterator = function () {
  function LoopIterator(source) {
    _classCallCheck(this, LoopIterator);

    this.source = source;
    this.maxLen = source.length;
    this.pos = -1;
  }

  _createClass(LoopIterator, [{
    key: 'hasNext',
    value: function hasNext() {
      return this.pos < this.maxLen - 1;
    }
  }, {
    key: 'getCurrent',
    value: function getCurrent() {
      return this.val;
    }
  }, {
    key: 'next',
    value: function next() {
      this.val = this.hasNext() ? this.source[++this.pos] : null;
      return this.val;
    }
  }, {
    key: 'getPrev',
    value: function getPrev() {
      return this.source[this.pos - 1];
    }
  }]);

  return LoopIterator;
}();

function templateClear(xml) {
  return xml.replace(REG_CLEAR_COMMENT, '').replace(REG_CLEAR_XMLHEAD, '');
}

function tokenizer(xml) {
  var tokens = [];
  var cur = new LoopIterator(xml);

  while (cur.hasNext()) {
    cur.next();

    // 1. match tag start
    if (cur.getCurrent() === '<') {
      var sub = {
        type: 'tag-start',
        name: ''
      };

      // check if close tag
      if (cur.next() === '/') {
        sub.isClose = true;
      } else {
        sub.name += cur.getCurrent();
      }

      // match tag name
      while (cur.hasNext() && !/[\s>]/.test(cur.next())) {
        sub.name += cur.getCurrent();
      }

      tokens.push(sub);

      continue;
    }

    // 2. match tag attrs
    if (/\w/.test(cur.getCurrent())) {
      var attrs = cur.getCurrent();

      while (cur.hasNext() && cur.next() !== '>') {
        attrs += cur.getCurrent();
      }

      if (cur.getPrev() === '/') {
        attrs = attrs.slice(0, -1);
      }

      tokens.push({
        type: 'attrs',
        value: attrs
      });
    }

    // 3. match tag end
    if (cur.getCurrent() === '>') {
      var _sub = {
        type: 'tag-end'
      };

      if (cur.getPrev() === '/') {
        _sub.isSelfCloseingTag = true;
      }

      tokens.push(_sub);
    }
  }

  return tokens;
}

function parser(tokens) {
  var cur = new LoopIterator(tokens);

  function processToken() {
    var result = [];

    currentFloor: while (cur.hasNext()) {
      var token = cur.next();
      var lastNotClosingTag = void 0;
      var vnode = {};

      currentTag: while (cur.hasNext()) {
        var _ret = function () {
          switch (token.type) {
            case 'tag-start':
              if (token.isClose) {

                // current floor tag
                if (lastNotClosingTag) {
                  return 'break|currentTag';
                }
                return 'break|currentFloor';
              }
              vnode.name = token.name;
              if (tagArr.indexOf(token.name) === -1) {
                tagArr.push(token.name);
              }
              break;
            case 'attrs':
              var attrs = {};
              // console.log(token.value.trim())
              // dinamic:hImageUrl="$const{https://gw.alicdn.com/tfs/TB1RldEnY9YBuNjy0FgXXcxcXXa-195-72.png?getAvatar=avatar}
              token.value && token.value.trim().match(REG_ATTR).forEach(function (attr) {

                // trim blank
                attr = attr.trim();
                eqIndex = attr.indexOf('=');

                var keyWithNamespace = attr.slice(0, eqIndex);
                var tagValue = attr.slice(eqIndex + 1);

                var _keyWithNamespace$spl = keyWithNamespace.split(':'),
                    _keyWithNamespace$spl2 = _slicedToArray(_keyWithNamespace$spl, 2),
                    namespace = _keyWithNamespace$spl2[0],
                    tagKey = _keyWithNamespace$spl2[1];

                if (namespace !== 'ios' && namespace !== 'android') {

                  // trim double-quo
                  attrs[tagKey || namespace] = tagValue.slice(1, -1);
                }
              });
              vnode.attrs = attrs;
              break;
            case 'tag-end':
              if (!token.isSelfCloseingTag) {
                vnode.children = processToken();
              }
              lastNotClosingTag = vnode.name;
              return 'break|currentTag';
          }
        }();

        switch (_ret) {
          case 'break|currentTag':
            break currentTag;

          case 'break|currentFloor':
            break currentFloor;}

        token = cur.next();
      }

      if (vnode.name) {
        result.push(vnode);
      }
    }

    return result;
  }

  return processToken();
}

module.exports = function (xml) {
  try {
    return parser(tokenizer(templateClear(xml)));
  } catch (e) {
    console.warn(e);
  }
};

/***/ })
/******/ ]);
});